import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-authenticate-layout',
    templateUrl: './authenticate-layout.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../authenticate.scss', './authenticate-layout.component.scss'],
    standalone: false,
})
export class FiAuthenticateLayoutComponent implements OnInit {
    @Input() contentClass = '';

    constructor() {}

    ngOnInit() {}
}
